var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnNoDeceptorsFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icn-deceptors",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.012,
    height: 43,
    viewBox: "0 0 46.012 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "screen",
    d: "M1116.637,1075h-35.317a3.829,3.829,0,0,0-3.821,3.816v26.406a3.8,3.8,0,0,0,3.8,3.8h35.317a3.829,3.829,0,0,0,3.82-3.816V1078.8A3.811,3.811,0,0,0,1116.637,1075Zm-.032,26.314a2.163,2.163,0,0,1-2.164,2.162h-9.9a1.831,1.831,0,0,0-1.743,1.268,1.273,1.273,0,0,1-1.212.882h-5.239a1.273,1.273,0,0,1-1.212-.882,1.831,1.831,0,0,0-1.743-1.268h-9.889a2.177,2.177,0,0,1-2.173-2.17v-20.5a2.162,2.162,0,0,1,2.164-2.161h30.935a2.177,2.177,0,0,1,2.172,2.17Z",
    transform: "translate(-1077.5 -1075)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "base",
    d: "M1169.74,1349.842h-4.7l-.929-3.757h-12.268l-.929,3.757h-4.7a1.648,1.648,0,1,0,0,3.3h23.533a1.648,1.648,0,1,0,0-3.3Z",
    transform: "translate(-1136.504 -1310.138)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "overlay",
    width: 9,
    height: 18,
    transform: "translate(26.92 27.783) rotate(-45)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "magnify-icn",
    transform: "translate(11.229 5.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17009",
    "data-name": "Group 17009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12907",
    "data-name": "Path 12907",
    d: "M1352.865,1381.664a1.183,1.183,0,0,0-1.183,1.184v6.977a1.183,1.183,0,0,0,2.367,0v-6.977A1.183,1.183,0,0,0,1352.865,1381.664Z",
    transform: "translate(-1342.019 -1377.607)",
    fill: "#fc5c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12908",
    "data-name": "Path 12908",
    d: "M1353.949,1441.564a1.2,1.2,0,0,0-.108-.21,1.852,1.852,0,0,0-.149-.177,1.224,1.224,0,0,0-1.67,0,1.155,1.155,0,0,0-.149.177,1.188,1.188,0,0,0-.109.21.8.8,0,0,0-.067.216,1.4,1.4,0,0,0-.027.237,1.127,1.127,0,0,0,.094.446,1,1,0,0,0,.257.385,1.206,1.206,0,0,0,.176.149.971.971,0,0,0,.2.108.93.93,0,0,0,.223.068,1.374,1.374,0,0,0,.23.027,1.132,1.132,0,0,0,.453-.095,1.045,1.045,0,0,0,.386-.257,1.075,1.075,0,0,0,.257-.385,1.121,1.121,0,0,0,.088-.446,1.4,1.4,0,0,0-.021-.237A1.113,1.113,0,0,0,1353.949,1441.564Z",
    transform: "translate(-1342.007 -1426.786)",
    fill: "#fc5c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12909",
    "data-name": "Path 12909",
    d: "M1988.293,255.679l-2.956-2.959q-2.292-2.293-4.584-4.585a1.146,1.146,0,0,1-.054-1.633c.011-.013.021-.026.026-.033l-2.641-2.641c-.178.13-.361.27-.549.4a10.55,10.55,0,0,1-4.977,1.882,10.722,10.722,0,0,1-9.037-3.153,10.555,10.555,0,0,1-3.022-5.829c-.06-.342-.088-.69-.132-1.036,0-.034-.015-.067-.023-.1V234.5c.033-.272.062-.544.1-.815a10.915,10.915,0,0,1,10.72-9.386,10.921,10.921,0,0,1,10.816,8.673,10.706,10.706,0,0,1-2.191,9.159c-.011.014-.022.027-.031.042a.046.046,0,0,0-.007.015l2.629,2.628a1.151,1.151,0,0,1,1.113-.3,1.243,1.243,0,0,1,.592.365l5.4,5.4,2.153,2.154a.364.364,0,0,1,0,.476l-2.771,2.774Zm-17.018-11.794a8.643,8.643,0,1,0-8.636-8.637A8.642,8.642,0,0,0,1971.274,243.885Z",
    transform: "translate(-1960.343 -224.299)",
    fill: "#fc5c5f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNoDeceptorsFound);
export default __webpack_public_path__ + "static/media/icn-no-deceptors-found.cd0023e70e0235c0c0f819d6311f6b39.svg";
export { ForwardRef as ReactComponent };